import { Languages } from "../../../../../components/ui/Languages/Languages";
import { Notifications } from "../Notifications/Notifications";
import { ThemeTriger } from "../ThemeTriger/ThemeTriger";

export const Actions = ({ isMobileMenu = false }) => (
    <div className="header-actions">
      <div className="header-actions__container">
        <div className="media__min-width-993--flex">
          <Languages menuDirection={"bottom"} />
        </div>
        <div className="media__max-width-992">
          <Languages menuDirection={"top"} />
        </div>
        {!isMobileMenu && <Notifications />}
        <ThemeTriger />
      </div>
    </div>
  );
